import { render, staticRenderFns } from "./WorkCompletionApproval.vue?vue&type=template&id=3c5bfa24&scoped=true"
import script from "./WorkCompletionApproval.vue?vue&type=script&lang=js"
export * from "./WorkCompletionApproval.vue?vue&type=script&lang=js"
import style0 from "./WorkCompletionApproval.vue?vue&type=style&index=0&id=3c5bfa24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5bfa24",
  null
  
)

export default component.exports